// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../gaswerk/assets/Figtree[wght].woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../gaswerk/assets/Figtree-Italic[wght].woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Figtree Font */
@font-face {
  font-family: "Figtree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2");
  font-weight: 300 900;
  font-style: normal;
}

@font-face {
  font-family: "Figtree";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff2");
  font-weight: 300 900;
  font-style: italic;
}

.text-layout-container {
  font-family: "Figtree", sans-serif;
}

.rotated-title,
.rotated-text {
  transform-origin: center;
}
`, "",{"version":3,"sources":["webpack://./functions/text-layout/styles.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,sBAAsB;EACtB,4DAAiE;EACjE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,4DAAwE;EACxE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":["/* Figtree Font */\n@font-face {\n  font-family: \"Figtree\";\n  src: url(\"../gaswerk/assets/Figtree[wght].woff2\") format(\"woff2\");\n  font-weight: 300 900;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"Figtree\";\n  src: url(\"../gaswerk/assets/Figtree-Italic[wght].woff2\") format(\"woff2\");\n  font-weight: 300 900;\n  font-style: italic;\n}\n\n.text-layout-container {\n  font-family: \"Figtree\", sans-serif;\n}\n\n.rotated-title,\n.rotated-text {\n  transform-origin: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
